/**
 * Macanese pataca.
 */
export var MOP = {
  code: 'MOP',
  base: 10,
  exponent: 2
};